import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { Property } from "@app/models/Property";
import { Homeowner } from "@app/models/Homeowner";
import { PaymentEntityType } from "@app/models/PaymentEntityType";
import { ProductApi } from "@app/services/apiServices/ProductApi";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'app-guest-payment-redirect',
    template: ``
})
export class GuestPaymentRedirect implements OnInit {

    paymentEntityType: PaymentEntityType;

    $stateParams: any;

    constructor(
        @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
        @Inject(ProductApi) private productApi: ProductApi,
        @Inject(NetworkErrorService) protected networkErrorService: NetworkErrorService,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private route: ActivatedRoute) {
        this.$stateParams = route.snapshot.queryParams;
    }

    ngOnInit() {
        this.paymentEntityType = this.route.snapshot.data.paymentEntityType;

        // Clear all saved values
        const tc = this.guestPaymentStore.getViewedTc()
        this.guestPaymentStore.clearAllGuest()
        this.guestPaymentStore.setViewedTc(tc || false)

        try {
            const homeowner = this.mapHomeowner(this.$stateParams);
            if (homeowner != null) {
                this.guestPaymentStore.setHomeowner(homeowner);
            }
        } catch (err) { console.warn(`Invalid homeowner`, err) }

        let property
        try {
            property = this.mapProperty(this.$stateParams);
            if (property != null) {
                this.guestPaymentStore.setProperty(property);
            }

            const amount = this.mapAmount(this.$stateParams);
            if (amount != null) {
                this.setAmountDueProduct(amount);
            }
        } catch (err) { console.warn(`Invalid property`, err) }

        if (this.paymentEntityType === PaymentEntityType.AMENITY)
            this.router.navigateByUrl('/amenities/guestpayment')
        else
            this.router.navigateByUrl('/guestpayment')
    }

    mapHomeowner(params: any): Homeowner {
        const homeowner: Homeowner = {
            firstName: params.first || "",
            lastName: params.last || "",
            id: null,
            contactInformation: {
                email: {
                    value: params.email || ""
                },
                phones: [
                    {
                        type: "",
                        countryCallingCode: "USA",
                        value: params.phonenum || ""
                    }
                ],
                notifyBySms: false
            }
        };
        return homeowner
    }

    mapProperty(params: any): Property {
        const property: Property = {
            couponId: params.propertyCouponId || null,
            hoa: {
                couponId: params.associationCouponId || null,
                pmc: {
                    couponId: params.managementCouponId || null
                },
            },
            nickname: params.line1 || null,
            address: {
                addressLine1: params.line1 || null,
                addressLine2: params.line2 || null,
                line1: params.line1 || null,
                line2: params.line2 || null,
                unit: params.unit || null,
                city: params.city || null,
                postalCode: params.postalCode ? params.postalCode.substr(0, 5) : null,
                state: params.state || null
            }
        }
        return property
    }

    mapAmount(params: any): number {
        if (!Number(params.amount)) return
        else if (Number(params.amount) < 0) {console.warn(`Invalid amount passed via parameters: ${params.amount}`); return null}
        return Number(params.amount)
    }

    setAmountDueProduct(amount) {
        let property = this.guestPaymentStore.getProperty();
        this.productApi.fetchProductOrganization(
            property.hoa.pmc.couponId,
            property.hoa.couponId,
        ).subscribe({
            next: resp => {
                if (resp != null) {
                    this.guestPaymentStore.setProducts(resp.products)
                    let amountDueProduct = resp.products.find(product => product.productType === 'send-amount-due');
                    if (amountDueProduct != null && amountDueProduct.productStatus === 'active') {
                        this.guestPaymentStore.setRedirectAmount(property, amount);
                    }
                }
            },
            error: err => {
                this.networkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((shouldRetry) => {
                    if (shouldRetry === true) {
                        this.setAmountDueProduct(amount);
                    }
                });
            } });
    }
}
